import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "ncgr-section ncgr-section--grouped-background ncgr-section--short ncgr-pad-t-24 ncgr-pad-b-24" }
const _hoisted_2 = { class: "ncgr-container -size-m" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "ncgr-heading -size-m ncgr-mar-b-8" }, " 「シルクスクリーン印刷」トリブンが増えるしくみ ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "ncgr-alert -color-warning -appearance-flat ncgr-mar-b-16" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "ncgr-ul -density-dense ncgr-typography-small" }, [
    /*#__PURE__*/_createElementVNode("li", null, " シルクスクリーン印刷では、注文された枚数に応じてSUZURIからの提供価格が下がるので、たくさん売れるほどもらえるトリブン(利益)単価が増加します。 "),
    /*#__PURE__*/_createElementVNode("li", null, " 注文された枚数に応じてトリブン単価が増加しても、クリエイターさんが決めた販売価格は変わりません。 "),
    /*#__PURE__*/_createElementVNode("li", null, " クリエイターさんの販売価格は (SUZURIからの提供価格 + トリブン) × (1 + 税率) です。 "),
    /*#__PURE__*/_createElementVNode("li", null, " 注文された枚数が、設定された目標数に達しなかった場合は、ホワイトインクジェットプリントで配送されます。 "),
    /*#__PURE__*/_createElementVNode("li", null, " 目標枚数やトリブン単価が増える条件は、アイテムや使用しているインクの色数によって異なりますので以下をご参照ください。 ")
  ])
], -1)
const _hoisted_5 = { class: "ncgr-heading -size-m ncgr-pad-16 ncgr-mar-b-16" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SuzuriHeader = _resolveComponent("SuzuriHeader")!
  const _component_AchievementLevelTable = _resolveComponent("AchievementLevelTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_SuzuriHeader),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.achievementLevels, (table, itemName) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "ncgr-card ncgr-card--rounded ncgr-mar-t-24 ncgr-pad-b-24",
            key: itemName
          }, [
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t(`item-name.${itemName}.long`)), 1),
            _createVNode(_component_AchievementLevelTable, {
              achievementLevels: table,
              itemName: itemName
            }, null, 8, ["achievementLevels", "itemName"])
          ]))
        }), 128))
      ])
    ])
  ]))
}